import { Box } from '@mui/material';
import { useForm } from 'react-hook-form';
import React from 'react';
import { useSnackbar } from 'notistack';
import { useSearchParams } from 'react-router-dom';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useGetLogsByUser } from '../../../../hooks/query/get-logs-by-user-query.hook';
import { useCreateCommentForClientOnly } from '../../../../hooks/mutation/create-comment-for-client-only-mutation.hook';
import { DisplayComment } from '../../../../common/logs/comment';
import { RichTextCustomLogs } from '../../../../common/logs/rich-text-custom-logs';

interface IFormInput {
  log_message: string
}

function Logs() {
  const [searchParams] = useSearchParams();
  const {
    control, handleSubmit, setValue, watch,
  } = useForm<IFormInput>({
    mode: 'onChange',
  });

  const queryInfo = useGetLogsByUser(searchParams.get('userId'));

  const { enqueueSnackbar } = useSnackbar();

  const mutate = useCreateCommentForClientOnly({
    onSuccess: (resp: any) => {
      setValue('log_message', '');
      queryInfo.refetch().then((r) => r);
    },
    onError: (err: any) => {
      enqueueSnackbar(err.message);
    },
  });

  const onSubmit = (form: any) => {
    const formValid: any = {
      data: {
        comment: form?.log_message,
        userId: searchParams.get('userId'),
      },
    };
    mutate({ ...formValid });
  };

  return (
    <Box>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
      >
        <RichTextCustomLogs
          name="log_message"
          control={control}
          watch={watch}
        />
      </Box>
      {queryInfo?.data?.getLogsByUser?.map((e, i) => {
        if ('comment' in e?.action) {
          return (
            <Box key={e?._id}>
              <DisplayComment
                picto={e?.createdBy?.email && e?.createdBy?.email.length > 1 ? `${e?.createdBy?.email[0]}${e?.createdBy?.email[1]}` : '...'}
                mail={e?.createdBy?.email}
                createdAt={e?.createdAt && format(new Date(Number(e?.createdAt)), 'dd MMMM yyyy', { locale: fr })}
                comment={e?.action?.comment}
                display={i + 1 === queryInfo?.data?.getLogsByUser?.length ? 'none' : 'inherit'}
              />
            </Box>
          );
        }
        return <Box key={e._id} />;
      })}
    </Box>
  );
}

export {
  Logs,
};
